const maskEmail = (email = '') => {
  const [local, domain] = email.split('@');

  if (!local || !domain) {
    return email;
  }

  if (local.length <= 2) {
    return `${'*'.repeat(local.length)}@${domain}`;
  }

  const stars = '*'.repeat(local.length - 2);
  return `${local[0]}${stars}${local[local.length - 1]}@${domain}`;
};

const EMAIL_OPTIONS = {
  NEW_EMAIL: 'newEmail',
  REGISTERED_EMAIL: 'registeredEmail',
};

export { EMAIL_OPTIONS, maskEmail };
